const viewerStore = {
  // Data-related stuff
  // path: "http://localhost:5000/pointclouds/", // locally, indirected through the server
  path:
    "https://naqab-resources.ams3.digitaloceanspaces.com/resources/pointclouds/",
  // "/Users/forensicarchitecture/code/negev/harddrive/resources/pointclouds/",
  filename: "/cloud.js",
  baseCloudName: "MaySep2018",
  //  clouds: ["January", "May", "November", "December"],
  pointclouds: {
    clouds: {
      MaySep2018: {
        label: "test",
        path: "MaySep2018",
        active: true
      },
      MaySouth2018: {
        label: "test 2",
        path: "MaySouth2018",
        active: true
      },
      /*January: {
       label: "Community satellite, January 2016",
       path: "January",
       active: true
      },
      May: {
       label: "Community satellite, May 2016",
       path: "May",
       active: true
      },
      November: {
       label: "Community satellite, November 2016",
       path: "November",
       active: true
     },*/
      December: {
        label: "Community satellite, December 2016",
        path: "December",
        active: true
      }
    }
  },

  // Scene, controls and camera
  cameraPosition: null, // other options: cameraPosition: [10,10,10],
  cameraTarget: [0, 0, 0], // other options: cameraTarget: [0,0,0],
  fov: 60, // field of view in degrees,
  navigation: "Orbit", // other options: "Earth", "Orbit", "Flight"

  // PointCloud rendering stuff
  sizeType: "Fixed", // options: "Adaptive", "Fixed", "Attenuated"
  quality: "Circle", // options: "Squares", "Circles", "Interpolation"
  material: "RGB", // other options: "Height", "Intensity", "Classification"
  pointLimit: Infinity, // max number of points in MM
  pointSize: 40
};

export default viewerStore;



// WEBPACK FOOTER //
// ./application/frontend/src/store/viewerStore.js